import { Directive, ElementRef, EventEmitter, HostListener, Input, Output, inject } from '@angular/core';

@Directive({
  selector: '[laScrollable]',
})
export class ScrollableDirective {
  @Input() threshold = 1;
  @Output() scrollPosition = new EventEmitter();

  private readonly el = inject(ElementRef);

  @HostListener('scroll', ['$event'])
  public onScroll(event: Event) {
    const top = (event.target as HTMLElement).scrollTop;
    const height = this.el.nativeElement.scrollHeight;
    const offset = this.el.nativeElement.offsetHeight;

    if (top > height - offset - this.threshold && height >= offset - 14) {
      this.scrollPosition.emit('bottom');
    }
  }
}
